import style from "../../assets/scss/sub/couponhistory.module.scss";
import { getAllCouponAsync, getAllCouponCountAsync } from "../../store/coupon/couponSlice";
import { useAppDispatch, useTimeConverter } from "../../hooks/hooks";
import React, { useCallback, useEffect, useState } from "react";
import { MyCoupon, ApiResponse } from "../../types/coupon";
import {Trans, useTranslation} from "react-i18next";
import {useMyPageFunctions} from "./mypage/useMyPageFunctions";
export function CouponHistory() {
  const { t } = useTranslation("coupon");
  const dispatch = useAppDispatch();

  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [coupons, setCoupons] = useState<MyCoupon[]>([]);
  const [totalCoupons, setTotalCoupons] = useState(0);
  const { timeConverter } = useTimeConverter();
  const { CommonPageField} = useMyPageFunctions();

  const getAllCouponList = useCallback(
    async (page: number) => {
      try {
        const response = (await dispatch(getAllCouponAsync(page)).unwrap()) as ApiResponse;
        const response2 = (await dispatch(getAllCouponCountAsync()).unwrap()) as ApiResponse;
        setCoupons(response.content);
        setTotalPages(response.totalPages || 1); // totalPages가 0이면 1로 설정
        setTotalCoupons(response2.totalElements);
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    getAllCouponList(currentPage).then();
    // eslint-disable-next-line
  }, [currentPage]);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  return (
    <div className={style.container}>
      <div className={style.containerContentBox}>
        <h2 className={style.containerTitle}>
          {t('title')} <span className={style.profileCount}>
          (<Trans t={t} i18nKey={"unit"} values={{coupons : totalCoupons}}/>)
          </span>
        </h2>
      </div>
      <div>
        {/* 지급일 쿠폰명 혜택 사용 기한 */}
        <div className={style.labelContainer}>
          <div className={style.firstLabel}>{t('detail.column.issuedAt')}</div>
          <div className={style.secondLabel}>{t('detail.column.couponName')}</div>
          <div className={style.thirdLabel}>{t('detail.column.benefits')}</div>
          <div className={style.fourthLabel}>{t('detail.column.expiredAt')}</div>
        </div>
        {/* 데이터 */}
        <div className={style.resultInfoContainer}>
          {coupons.length > 0 ? (
            coupons.map((coupon) => (
              <div key={coupon.idx} className={style.resultInfoData}>
                <div className={style.firstInfoData}>
                  {timeConverter.convertToFormattedDate(timeConverter.convertToLocalDate(coupon.availableStartAt))}
                </div>
                <div className={style.secondInfoData}>{coupon.coupon.name}</div>
                <div className={style.thirdInfoData}>
                  {coupon.coupon.point
                    ? `${coupon.coupon.point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${t('detail.row.amountSale')}`
                    : `${coupon.coupon.percent}${t('detail.row.percentSale')}`}
                </div>
                <div className={style.fourthInfoData}>
                  {timeConverter.convertToFormattedDate(timeConverter.convertToLocalDate(coupon.availableEndAt))}
                </div>
              </div>
            ))
          ) : (
            <div className={style.noPaymentInfo}>{t('detail.row.emptyCoupon')}</div>
          )}
        </div>

        {/* 페이지네이션 */}
        <CommonPageField handlePageChange={handlePageChange} currentPage={currentPage} totalPages={totalPages} />
      </div>
    </div>
  );
}
